<template>
    <div @click="$emit('click')" class="clickable" v-tooltip="'Share'">
        <font-awesome-icon icon="share" />
    </div>
</template>

<script>
    export default {
        name: "Share"
    }
</script>

<style scoped>

</style>